<template>
    <div class="an-box">
        <div class="box-item1" style="height:14vh;">
            <div class="box-item1-t">
                <p class="box-t-l">累计统计：</p>
                <div class="box-t-r">
                    <p class="con" style="background:#597EF0;cursor: pointer;" @click="toPersonList(1)">
                        <span style="width:100%;text-align: left;color:#fff;">{{anData.registered}}</span>
                        <span style="width:100%;text-align: left;color:#fff;">注册人数</span>
                    </p>
                    <p class="con" style="background:#1D9DE4;cursor: pointer;" @click="toPersonList(2)">
                        <span style="width:100%;text-align: left;color:#fff;">{{anData.unregistered}}</span>
                        <span style="width:100%;text-align: left;color:#fff;">核验人数</span>
                    </p>
                    <p class="con" style="background:#909399;cursor: pointer;" @click="toPersonList(6)">
                        <span style="width:100%;text-align: left;color:#fff;">{{anData.gray}}</span>
                        <span style="width:100%;text-align: left;color:#fff;">灰码人数</span>
                    </p>
                    <p class="con" style="background:#0CCF93;cursor: pointer;" @click="toPersonList(3)">
                        <span style="width:100%;text-align: left;color:#fff;">{{anData.green}}</span>
                        <span style="width:100%;text-align: left;color:#fff;">正常绿码人数</span>
                    </p>
                    <p class="con" style="background:#F8DA2A;cursor: pointer;" @click="toPersonList(4)">
                        <span style="width:100%;text-align: left;color:#fff;">{{anData.yellow}}</span>
                        <span style="width:100%;text-align: left;color:#fff;">异常黄码人数</span>
                    </p>
                    <p class="con" style="background:#F9693B;cursor: pointer;" @click="toPersonList(5)">
                        <span style="width:100%;text-align: left;color:#fff;">{{anData.red}}</span>
                        <span style="width:100%;text-align: left;color:#fff;">异常红码人数</span>
                    </p>
                    <p class="con" style="background:#F9693B;cursor: pointer;" @click="toPersonList(7)">
                        <span style="width:100%;text-align: left;color:#fff;">{{anData.redRecodeCount}}</span>
                        <span style="width:100%;text-align: left;color:#fff;">异常红码记录</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="box-item1" style="height:calc( 100% - 18vh );margin-top:4vh;border-bottom:0;">
            <!-- <div class="box-item1-t">
                <p class="box-t-l">当月统计：</p>
                <div class="box-t-r">
                    <p class="con" style="background:#597EF0;">
                        <span style="width:100%;text-align: left;color:#fff;">0</span>
                        <span style="width:100%;text-align: left;color:#fff;">登记人数</span>
                    </p>
                    <p class="con" style="background:#1D9DE4;">
                        <span style="width:100%;text-align: left;color:#fff;">0</span>
                        <span style="width:100%;text-align: left;color:#fff;">累计人数</span>
                    </p>
                    <p class="con" style="background:#0CCF93;">
                        <span style="width:100%;text-align: left;color:#fff;">0</span>
                        <span style="width:100%;text-align: left;color:#fff;">正常绿码</span>
                    </p>
                    <p class="con" style="background:#F8DA2A;">
                        <span style="width:100%;text-align: left;color:#fff;">0</span>
                        <span style="width:100%;text-align: left;color:#fff;">异常黄码</span>
                    </p>
                    <p class="con" style="background:#F9693B;">
                        <span style="width:100%;text-align: left;color:#fff;">0</span>
                        <span style="width:100%;text-align: left;color:#fff;">异常红码</span>
                    </p>
                </div>
            </div> -->
            <div class="box-item1-b">
                <p class="box-t-l" style="font-weight: bold;align-content: flex-start;align-items: flex-start;padding-top:2vh;">人员登记统计：</p>
                <div class="box-t-r" >
                    <div class="hight-line" id="bar1" style="height:100%;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HighCharts from 'highcharts'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
export default {
    data(){
        return {
            anData:{
                groupId:'',
                anData:{
                    registered:0,//安康码已注册人数
                    unregistered:0,//安康码核验人数
                    green:0,
                    yellow:0,
                    red:0,
                    gray:0,//未核验人数
                    redRecodeCount:0,//红码记录
                },
            },
            chartShow:false,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData()
        this.getLine()
        this.showLine1()
    },
    methods:{

        //获取数据
        getData(){
            var that = this
            // dayStatisticalAnKang
            myHttp.dayStatisticalAnKang({
                projectId:this.groupId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    that.anData = resp.data.data
                }
            })
        },
        //获取柱状图
        getLine(){
            var that = this
            myHttp.monthStatistical({
                projectId:this.groupId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    that.chartShow = true
                    that.showLine1(data)
                }else{
                    that.chartShow = true
                }
            },function(){
                that.chartShow = true
            })
        },
        //展示line1
        showLine1(data){
            data = data?data:{
                inCumulative:0,
                registered:0,
                green:0,
                yellow:0,
                red:0
            }
            HighCharts.chart('bar1', {
                chart: {
                    type: 'column'
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                colors:['#5995FD'],
                xAxis: {
                    type: 'category',
                    // labels: {
                    //     rotation: -45  // 设置轴标签旋转角度
                    // },
                    title: {
                        text: '',
                        align:'high',
                        style:{
                            fontSize:'10'
                        }
                    }
                },
                yAxis: {
                    // min: 0,
                    allowDecimals: false,
                    title: {
                        text: '',
                        align:'high'
                    },
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y:.0f} 人</b>',
                    headerFormat:'{series[0].center[1]}<br/>'
                },
                series: [{
                    name: '人数',
                    borderRadius:'0',
                    maxPointWidth:15,
                    data: [
                        ['今日入场', parseInt(data.registered)],
                        ['月累计入场', parseInt(data.inCumulative)],
                        ['今日灰码', parseInt(data.gray)],
                        ['今日绿码', parseInt(data.green)],
                        ['今日黄码', parseInt(data.yellow)],
                        ['今日红码', parseInt(data.red)],
                    ],
                }]
            });
        },


        //跳转统计列表
        toPersonList(index){
            if(index=='1'||index=='2'){
            this.$router.push({ path: '/anKangPerson/' + index })
            }else{
            this.$router.push({ path: '/anKangCount/' + index })

     }
        },
    },

}
</script>

<style scoped>
    .an-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh 2vw;
        background: #fff;
    }
    .box-item1{
        width: 100%;
        height: 50%;
        position: relative;
        border-bottom: 1px solid #ddd;
    }
    .box-item1-t{
        width: 100%;
        height: 10vh;
        position: relative;
        display: flex;
    }
    .box-t-l{
        width: 10%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: flex-end;
        justify-items: flex-end;
        align-content: center;
        align-items: center;
    }
    .box-t-r{
        width: 90%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
    }
    .box-t-r .con{
        width: 12%;
        height: 80%;
        padding: 1vh 1vw;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        justify-items: flex-start;
        align-content: space-between;
        border-radius: 6px;
    }
    .box-item1-b{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        margin-top: 1vh;
    }

    .hight-line{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>

</style>